import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Mutation, Query } from 'react-apollo'
import { Link } from 'react-router-dom'
import moment from 'moment'
import {
  message, Menu, Dropdown, Icon, Button, Select, Popconfirm, Modal, DatePicker, Col, Radio,
} from 'antd'
import {
  SmallText, Div, Button as KonsysButton, InputWithLabel,
} from 'konsys-ui'
import { useMutation, useQuery } from '@apollo/react-hooks'
import {
  CANCEL_JOB, CREATE_GARAGE, CREATE_FUEL_ORDER_FOR_REPAIR_JOB, EDIT_FUEL_ORDER_FOR_REPAIR_JOB,
} from '../../constants/graphql/mutation'
import {
  DRIVER_LIST, GET_MECHANICS, GET_USERS, GAS_STATION_LIST,
} from '../../constants/graphql/query'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { P } from '../../pages/repair-job-page/styled'
import PERMISSION from '../../constants/permissions'
import { status as repairJobStatus, servicesStatus } from '../../pages/repair-job-page/constants'
import { checkNotNumber, checkInt } from '../../utils/util-services'
import { fuelTypeList, statusList } from '../../pages/filling-order-page/detail/component-renderer'
import { getAccessToken, getURL } from '../../utils/local-data-service'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)} />
)

const menu = id => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_REPAIR)}>
        <Link to={`/repair-job/view/${id}`} target="_blank">
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_REPAIR)}>
        <Link to={`/repair-job/edit/${id}`} target="_blank">
          แก้ไข
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const DropdownSelector = ({
  data, handleChange, width,
}) => (
    <Select
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width: width - 10 }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
      {
        data.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
      }
    </Select>
)

export const ActionSelector = ({ props: { original: { id } } }) => (
  <Dropdown overlay={menu(id)} trigger='click'>
    <Button>
      ดูรายละเอียด <Icon type="down" />
    </Button>
  </Dropdown>
)

export const InputWithLabelBlock = ({
  data, onChangeHandler, maxLength, isFloat, margin,
}) => (
    <Div display='flex' alignItems='flex-end'>
      <InputWithLabel {...data.props}
        margin={margin || '0'}
        input={{
          type: isFloat ? 'number' : 'text',
          step: isFloat ? '0.1' : undefined,
          min: '0',
          max: maxLength,
          value: data.value,
          onKeyDown: e => isFloat && checkNotNumber(e) && e.preventDefault(),
          onChange: e => onChangeHandler(data.id, isFloat ? parseFloat(e.target.value) : e.target.value),
          defaultValue: data.defaultValue,
          disabled: data.disabled,
        }}
      />
    </Div>
)

export const DatePickerWithLabel = ({ data, onChangeHandler, disabledDate }) => (
  <Div display='flex' flexDirection='column' margin='0'>
    <P margin='0 0 16px'>{data.text}</P>
    <DatePicker
      disabledDate={disabledDate}
      value={moment(data.value).isValid() && moment(data.value)}
      disabled={data.disabled}
      defaultValue={moment(data.defaultValue).isValid() && moment(data.defaultValue)}
      onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))}
    />
  </Div>
)

export const InputWithLabelInt = ({
  data, onChangeHandler, maxLength, isInt, margin,
}) => (
    <Div display='flex' alignItems='flex-end'>
      <InputWithLabel {...data.props}
        margin={margin || '0'}
        input={{
          type: isInt ? 'number' : 'text',
          step: isInt ? '1' : undefined,
          min: '0',
          max: maxLength,
          value: data.value,
          onKeyDown: e => isInt && !checkInt(e) && e.preventDefault(),
          onChange: e => onChangeHandler(data.id, isInt ? parseFloat(e.target.value) : e.target.value),
          defaultValue: data.defaultValue,
          disabled: data.disabled,
        }}
      />
    </Div>
)

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const FuelOrderRepairJob = ({
  data,
}) => (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' alignItems='center' justifyContent='flex-start' padding='32px 0 40px 0'>
        <Div display='flex' flexDirection='column' width='25%'>
          <P margin='0 0 16px'>ขนจาก (ต้นทาง)</P>
          <P>{data.start}</P>
        </Div>
        <Div display='flex' flexDirection='column' width='25%'>
          <P margin='0 0 16px'>ขนไป (ต้นทาง)</P>
          <P>{data.end}</P>
        </Div>
        <Div display='flex' flexDirection='column' width='25%'>
          <P margin='0 0 16px'>วันหมดอายุ</P>
          <P>{moment(data.expiredDate).format('DD-MM-YYYY')}</P>
        </Div>
        <Div display='flex' flexDirection='column' width='25%'>
          <P margin='0 0 16px'>ปั๊มน้ำมัน</P>
          <P>{data.Gasstation ? data.Gasstation.name : 'บริษัท ผดุงฤทธิ์'}</P>
        </Div>
      </Div>
      <Div display='flex' flexDirection='row' alignItems='center' justifyContent='flex-start' padding='0 0 40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
        <Div display='flex' flexDirection='column' width='25%'>
          <P margin='0 0 16px'>ประเภทเชื้อเพลิง</P>
          <P>{data.fuelType}</P>
        </Div>
        <Div display='flex' flexDirection='column' width='25%'>
          <P margin='0 0 16px'>ราคาต่อลิตร</P>
          <P>{data.pricePerLitre}</P>
        </Div>
        <Div display='flex' flexDirection='column' width='25%'>
          <P margin='0 0 16px'>ปริมาณทั้งหมด</P>
          <P>{data.totalAmount} ลิตร</P>
        </Div>
        <Div display='flex' flexDirection='column' width='25%'>
          <P margin='0 0 16px'>ราคา</P>
          <P>{data.price}</P>
        </Div>
      </Div>
    </Div>
)

export const AddGarageModal = ({ addGarageModal, setAddGarageModal }) => {
  const [name, setName] = useState()
  const [phoneNumber, setPhoneNumber] = useState()
  const [address, setAddress] = useState()
  return (
    <Mutation
      mutation={CREATE_GARAGE}
      refetchQueries={['GarageList']}
    >{(doAction, { loading: addGarageLoading }) => (
      <Modal
        title="เพิ่มศูนย์บริการ"
        visible={addGarageModal}
        destroyOnClose={true}
        onCancel={() => {
          setAddGarageModal(false)
          setName()
          setPhoneNumber()
          setAddress()
        }}
        onOk={() => {
          doAction({
            variables: {
              name,
              phoneNumber,
              address,
            },
          }).then(({ data }) => {
            const resp = data.CreateGarage
            if (resp.success) {
              message.success(resp.message)
            } else message.error(resp.message)
          })
          setAddGarageModal(false)
          setName()
          setPhoneNumber()
          setAddress()
        }}
        okButtonProps={{
          loading: addGarageLoading,
          disabled: addGarageLoading || _.isEmpty(name) || _.isEmpty(phoneNumber),
        }}
        cancelButtonProps={{
          disabled: addGarageLoading,
        }}
      >
        <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
          <InputWithLabel
            title={{ text: 'ชื่อศูนย์บริการ *' }}
            margin='0 16px 0 0'
            input={{ onChange: e => setName(e.target.value), value: name }} />
        </Div>
        <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
          <InputWithLabel
            title={{ text: 'เบอร์โทรศัพท์ *' }}
            margin='0 16px 0 0'
            input={{ onChange: e => setPhoneNumber(e.target.value), value: phoneNumber }} />
        </Div>
        <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
          <InputWithLabel
            title={{ text: 'ที่อยู่' }}
            margin='0 16px 0 0'
            input={{ onChange: e => setAddress(e.target.value), value: address }} />
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}

export const EditFuelModal = (props) => {
  const [pricePerLitre, setPricePerLitre] = useState()
  const [totalAmount, setTotalAmount] = useState(1)
  const [doAction, { loading: mutationLoading }] = useMutation(EDIT_FUEL_ORDER_FOR_REPAIR_JOB)
  useEffect(() => {
    setPricePerLitre(props?.fuelOrder?.pricePerLitre)
    setTotalAmount(props?.fuelOrder?.totalAmount)
  }, [props.fuelOrder])
  return (
    <Modal
      title="แก้ไขใบเบิกน้ำมัน"
      visible={props.editFuelModal}
      destroyOnClose={true}
      centered
      onCancel={() => {
        props.setEditFuelModal(false)
      }}
      onOk={() => {
        doAction({
          variables: {
            pricePerLitre,
            totalAmount,
            id: props?.fuelOrder?.id,
          },
          refetchQueries: ['RepairJobInfo'],
        }).then(({ data }) => {
          const resp = data.UpdateRepairJobFuel
          if (resp.success) {
            message.success(resp.message)
            props.setEditFuelModal(false)
          } else message.error(resp.message)
        })
      }}
      okButtonProps={{
        loading: mutationLoading,
        disabled: mutationLoading || _.isUndefined(pricePerLitre) || _.isUndefined(totalAmount),
      }}
      cancelButtonProps={{
        disabled: mutationLoading,
      }}
    >
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <InputWithLabel
          title={{ text: 'ราคาต่อลิตร *' }}
          margin='0 16px 0 0'
          input={{
            onChange: (e) => {
              if (_.isNaN(parseFloat(e.target.value)) || (parseFloat(e.target.value) >= 0 && parseFloat(e.target.value) <= 80)) setPricePerLitre(parseFloat(e.target.value))
            },
            value: pricePerLitre,
            type: 'number',
          }} />
      </Div>
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <InputWithLabel
          title={{ text: 'ปริมาณทั้งหมด (ลิตร) *' }}
          margin='0 16px 0 0'
          input={{
            onChange: (e) => {
              if (_.isNaN(parseFloat(e.target.value)) || (parseFloat(e.target.value) >= 0 && parseFloat(e.target.value) <= 500)) setTotalAmount(parseFloat(e.target.value))
            },
            value: totalAmount,
            type: 'number',
          }} />
      </Div>
    </Modal>
  )
}

const FuelOrderModal = ({
  fuelOrderModal, setFuelOrderModal, props, setPrintLoading,
}) => {
  const [pricePerLitre, setPricePerLitre] = useState()
  const [totalAmount, setTotalAmount] = useState()
  const [fuelType, setFuelType] = useState()
  const [mechanicId, setMechanicId] = useState()
  const [driverId, setDriverId] = useState()
  const [userId, setUserId] = useState()
  const [gasstationId, setGasstationId] = useState()
  const [expiredDate, setExpiredDate] = useState(moment().format('YYYY-MM-DD'))
  const [start, setStart] = useState('บริษัท ผดุงฤทธิ์ขนส่ง จำกัด')
  const [end, setEnd] = useState('บริษัท ผดุงฤทธิ์ขนส่ง จำกัด')
  const [isMechanicDrive, setIsMechanicDrive] = useState(true)
  const [isDriverDrive, setIsDriverDrive] = useState(false)
  const [isUserDrive, setIsUserDrive] = useState(false)
  const [doAction, { loading: mutationLoading }] = useMutation(CREATE_FUEL_ORDER_FOR_REPAIR_JOB)
  const {
    loading: driverLoading, data: driverData, error: driverError, refetch: driverRefetch,
  } = useQuery(DRIVER_LIST)
  const {
    loading: mechLoading, data: mechData, error: mechError, refetch: mechRefetch,
  } = useQuery(GET_MECHANICS)
  const {
    loading: userLoading, data: userData, error: userError, refetch: userRefetch,
  } = useQuery(GET_USERS)
  const {
    loading: gasLoading, data: gasData, error: gasError, refetch: gasRefetch,
  } = useQuery(GAS_STATION_LIST, { variables: { isActive: true } })
  return (
    <Modal
      title="พิมพ์ใบเบิกน้ำมัน"
      visible={fuelOrderModal}
      destroyOnClose={true}
      centered
      onCancel={() => {
        setFuelOrderModal(false)
      }}
      onOk={() => {
        doAction({
          variables: {
            pricePerLitre,
            totalAmount,
            price: totalAmount * pricePerLitre,
            fuelType,
            expiredDate,
            start,
            userId,
            mechanicId,
            gasstationId,
            driverId,
            end,
            repairId: parseInt(props.match.params.id, 10),
          },
          refetchQueries: ['RepairJobInfo'],
        }).then(({ data }) => {
          const resp = data.CreateRepairJobFuel
          if (resp.success) {
            const token = getAccessToken()
            const url = `${getURL().FILE_SERVER}/downloadfile/pdf/repairjob/fuelOrder/${resp.createdRepairJobFuel.id}?t=${token}`
            window.open(
              url,
              '_blank',
              'toolbar=false,scrollbars=yes,resizable=false',
            )
            setFuelOrderModal(false)
            setPricePerLitre()
            setTotalAmount()
            setFuelType()
            setMechanicId()
            setUserId()
            setDriverId()
            setGasstationId()
            setExpiredDate(moment().format('YYYY-MM-DD'))
            setStart('บริษัท ผดุงฤทธิ์ขนส่ง จำกัด')
            setEnd('บริษัท ผดุงฤทธิ์ขนส่ง จำกัด')
            setIsMechanicDrive(true)
            setIsDriverDrive(false)
            setIsUserDrive(false)
          } else message.error(resp.message)
        })
      }}
      okButtonProps={{
        loading: mutationLoading,
        disabled: mutationLoading || _.isUndefined(pricePerLitre) || _.isUndefined(totalAmount) || _.isEmpty(fuelType) || (_.isUndefined(userId) && _.isUndefined(mechanicId) && _.isUndefined(driverId)),
      }}
      cancelButtonProps={{
        disabled: mutationLoading,
      }}
    >
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <DatePickerWithLabel
          disabledDate={current => current && current < moment().subtract(1, 'd').endOf('day')}
          data={{
            value: !_.isUndefined(expiredDate) && moment(expiredDate),
            id: 'expireDate',
            text: 'วันหมดอายุ *',
          }}
          onChangeHandler={(key, value) => setExpiredDate(value)}
        />
      </Div>
      <Div display='block'>
        <P margin='0 0 16px'>ผู้เบิกน้ำมัน</P>
      </Div>
      <Div display='inline-block' flexDirection='column' margin='0 0 16px'>
        <Radio.Group
          defaultValue={1}
          onChange={(e) => {
            switch (e.target.value) {
              case 1: {
                setIsMechanicDrive(true)
                setIsDriverDrive(false)
                setIsUserDrive(false)
                break
              }
              case 2: {
                setIsMechanicDrive(false)
                setIsDriverDrive(true)
                setIsUserDrive(false)
                break
              }
              case 3: {
                setIsMechanicDrive(false)
                setIsDriverDrive(false)
                setIsUserDrive(true)
                break
              }
              default: {
                setIsMechanicDrive(false)
                setIsDriverDrive(false)
                setIsUserDrive(false)
                break
              }
            }
            setMechanicId()
            setUserId()
            setDriverId()
          }}
        >
          <Radio value={1}>ช่าง</Radio>
          <Radio value={2}>คนขับรถ</Radio>
          <Radio value={3}>ผู้ใช้ระบบ</Radio>
        </Radio.Group>
      </Div>
      { isMechanicDrive && !(mechLoading && _.isEmpty(mechData))
        && <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <Select
        style={{ width: 210 }}
        showSearch
        optionFilterProp="children"
        onChange={(e) => {
          setMechanicId(e)
        }}
        onSearch={e => mechRefetch({ firstname: e })}
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {
          mechData.MechanicList.lists.map((v, i) => <Select.Option key={i} value={v.id}>{v.firstname}</Select.Option>)
        }
      </Select>
      </Div>
      }
      { isDriverDrive && !(driverLoading && _.isEmpty(driverData))
        && <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <Select
        style={{ width: 210 }}
        showSearch
        optionFilterProp="children"
        onSearch={e => driverRefetch({ fullname: e })}
        onChange={(e) => {
          setDriverId(e)
        }}
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {
          driverData.DriverList.lists.map((v, i) => <Select.Option key={i} value={v.id}>{v.fullname}</Select.Option>)
        }
      </Select>
      </Div>
      }
      { isUserDrive && !(userLoading && _.isEmpty(userData))
        && <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <Select
        style={{ width: 210 }}
        showSearch
        optionFilterProp="children"
        onSearch={e => userRefetch({ name: e })}
        onChange={(e) => {
          setUserId(e)
        }}
        filterOption={true}
      >
        {
          userData.UserList.lists.map((v, i) => <Select.Option key={i} value={v.userId}>{v.firstname} {v.lastname}</Select.Option>)
        }
      </Select>
      </Div>
      }
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <InputWithLabel
          title={{ text: 'ต้นทาง *' }}
          margin='0 16px 0 0'
          input={{ onChange: e => setStart(e.target.value), value: start }} />
      </Div>
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <InputWithLabel
          title={{ text: 'ปลายทาง *' }}
          margin='0 16px 0 0'
          input={{ onChange: e => setEnd(e.target.value), value: end }} />
      </Div>
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <Col span={24} style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 70,
        }}>
          <P>ปั๊มน้ำมัน</P>
          <Select
            style={{ width: 210 }}
            showSearch
            optionFilterProp="children"
            loading={gasLoading}
            onSearch={e => gasRefetch({ name: e })}
            onChange={(e) => {
              setGasstationId(e)
            }}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              !(gasLoading && _.isEmpty(gasData))
              && gasData.GasstationList.lists.map((v, i) => <Select.Option key={i} value={v.id}>{v.name}</Select.Option>)
            }
          </Select>
        </Col>
      </Div>
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <Col span={24} style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 70,
        }}>
          <P>ประเภทเชื้อเพลิง *</P>
          <Select
            style={{ width: 210 }}
            showSearch
            optionFilterProp="children"
            onChange={(e) => {
              setFuelType(e)
            }}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              fuelTypeList.map((v, i) => <Select.Option key={i} value={v.value}>{v.text}</Select.Option>)
            }
          </Select>
        </Col>
      </Div>
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <InputWithLabel
          title={{ text: 'ราคาต่อลิตร *' }}
          margin='0 16px 0 0'
          input={{
            onChange: (e) => {
              if (_.isNaN(parseFloat(e.target.value)) || (parseFloat(e.target.value) >= 0 && parseFloat(e.target.value) <= 80)) setPricePerLitre(parseFloat(e.target.value))
            },
            value: pricePerLitre,
            type: 'number',
          }} />
      </Div>
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <InputWithLabel
          title={{ text: 'ปริมาณทั้งหมด (ลิตร) *' }}
          margin='0 16px 0 0'
          input={{
            onChange: (e) => {
              if (_.isNaN(parseFloat(e.target.value)) || (parseFloat(e.target.value) >= 0 && parseFloat(e.target.value) <= 500)) setTotalAmount(parseFloat(e.target.value))
            },
            value: totalAmount,
            type: 'number',
          }} />
      </Div>
    </Modal>
  )
}

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled, refetch, status, services, setCloseJobModal,
}) => {
  const [printloading, setPrintLoading] = useState(false)
  const [fuelOrderModal, setFuelOrderModal] = useState(false)

  const downloadRepair = (id) => {
    setPrintLoading(true)
    const token = getAccessToken()
    const url = `${getURL().FILE_SERVER}/render/pdf/repairjob/${id}?t=${token}`
    window.open(
      url,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    setPrintLoading(false)
  }

  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      {
        !_.includes([repairJobStatus.COMPLETED, repairJobStatus.CANCEL], status) && _.size(_.filter(services, o => _.includes([servicesStatus.DONE], o.status))) === 0 && !isAddMode
        && <Mutation
          mutation={CANCEL_JOB}
        >{doCancelJob => (
          <Popconfirm
            title="ต้องการยกเลิกใบแจ้งซ่อม?"
            onConfirm={() => {
              doCancelJob({
                variables: {
                  id: _.toSafeInteger(props.match.params.id),
                },
              }).then((res) => {
                const resp = res.data.CancelRepairJob
                if (resp.success) {
                  message.success(resp.message)
                  refetch()
                } else message.error(resp.message)
              })
            }}
            okText="ยกเลิกใบแจ้งซ่อม"
            cancelText="เก็บไว้"
          >
            <KonsysButton
              small
              color={color.error}
              // disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_CLIENT)) || disabled}
              text={'ยกเลิกใบแจ้งซ่อม'}
              icon={'fas fa-times-circle'}
              inverse
            />
          </Popconfirm>
        )}
        </Mutation>
      }
      {
        !_.includes([repairJobStatus.COMPLETED, repairJobStatus.CANCEL], status) && !isAddMode
        && <KonsysButton
          margin='0 0 0 16px'
          text='พิมพ์ใบเบิกน้ำมัน'
          icon='fas fa-print'
          loading={printloading}
          disabled={printloading || !_.includes(window.perms, PERMISSION.VIEW_REPAIR) || isAddMode}
          onClick={() => {
            setFuelOrderModal(true)
          }}
        />
      }
      {
        _.size(_.filter(services, o => !_.includes([servicesStatus.DONE, servicesStatus.CANCEL], o.status))) === 0 && !_.includes([repairJobStatus.COMPLETED, repairJobStatus.CANCEL], status) && !isAddMode && _.size(_.filter(services, o => _.includes([servicesStatus.DONE], o.status))) > 0
        && <Popconfirm
          title="ต้องการปิดงานซ่อม?"
          onConfirm={() => {
            setCloseJobModal(true)
          }}
          okText="ปิดงานซ่อม"
          cancelText="เก็บไว้"
        >
          <KonsysButton
            small
            color={color.success}
            // disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_CLIENT)) || disabled}
            text={'ปิดงานซ่อม'}
            icon={'fas fa-check-circle'}
            margin='0 0 0 16px'
            inverse
          />
        </Popconfirm>
      }
      <KonsysButton
        margin='0 0 0 16px'
        text='พิมพ์แจ้งซ่อม'
        icon='fas fa-print'
        loading={printloading}
        disabled={printloading || !_.includes(window.perms, PERMISSION.VIEW_REPAIR) || isAddMode}
        onClick={() => {
          downloadRepair(props.match.params.id)
        }}
      />
      <KonsysButton
        margin='0 0 0 16px'
        loading={loading}
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_REPAIR)) || disabled}
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={() => {
          if (isViewMode) history.push(`/repair-job/edit/${props.match.params.id}`)
          else {
            doAction({
              variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreateRepairJob : data.UpdateRepairJob
              if (resp.success) {
                message.success(resp.message)
                if (isAddMode) history.push('/repair-job')
                // else history.push(`/client/view/${props.match.params.id}`)
              } else message.error(resp.message)
            })
          }
        }}
      />
      <FuelOrderModal
        fuelOrderModal={fuelOrderModal}
        setFuelOrderModal={setFuelOrderModal}
        props={props}
        setPrintLoading={setPrintLoading}
      />
    </Div>
  )
}
